import React from "react";
import { Route } from "react-router-dom";
import { getCurrentUser } from "../../services/authService";

const ProtectedRoute = (props) => {
  const { path, component: Component, render, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!getCurrentUser()) {
          window.location = "/login";
        } else {
          return Component ? <Component {...props} /> : render(props);
        }
      }}
    />
  );
};

export default ProtectedRoute;
